import React from "react";
import LeftCircleIconImage from "../../assets/images/LeftCircle.svg";

const LeftCircleIcon = ({ onClick = () => {} }) => {
  return (
    <img
      src={LeftCircleIconImage}
      alt="Previous"
      className="left-circle-icon"
      onClick={onClick}
    />
  );
};

export default LeftCircleIcon;
